let download
import('downloadjs').then(d => download = d.default);

export default function downloadVideo(url) {
    const x = new XMLHttpRequest();
    x.open('GET', url, true);
    x.responseType = 'blob';
    x.onload = function(e) {
        download && download(e.target.response, 'ActionButtonRecording.mp4', 'video/mp4');
    };
    x.send();
}